import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { getCookie } from 'util/cookies';
import * as profileActions from 'actions/Profile';
import * as profileApi from 'api/Profile';
import { showAuthMessage } from 'actions/Auth';
import { history } from 'store';
import { showSuccessNotification, showErrorNotification } from 'actions/App';
import {
  GET_CURRENT_USER,
  CHANGE_PASSWORD,
  GET_PROFILE_SETTINGS,
  CHANGE_PERMISSIONS,
  GET_SCHOOL_BY_TENANT,
  GET_ROUTES_FOR_PROFILE,
} from 'constants/ActionTypes';
import { TENANT_ID_KEY } from 'constants/Values';
import * as routesApi from 'api/Routes';

function* getCurrentUser() {
  try {
    const { data } = yield call(profileApi.getCurrentUser);
    yield put(profileActions.getCurrentUserSuccess(data));
  } catch (error) {
    yield put(showAuthMessage(error.messages));
  }
}

function* changePassword({ payload }) {
  const { newPassword, currentPassword } = payload;
  try {
    yield call(profileApi.changePassword, currentPassword, newPassword);
    yield put(showSuccessNotification('appModule.passwordChanged'));
    yield put(profileActions.changePasswordSuccess());
    yield call(history.push, '/profile');
  } catch (error) {
    if (error && (!error.errors || !error.errors.length)) {
      yield put(showErrorNotification('errors.changePassword'));
    }
    yield put(profileActions.changePasswordError(error));
  }
}

function* getProfileSettings({ payload }) {
  yield put(profileActions.setProfileSettingsLoading(true));

  try {
    const { data } = yield call(profileApi.getProfileSettings, payload.userId);

    yield put(profileActions.getProfileSettingsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }

  yield put(profileActions.setProfileSettingsLoading(false));
}

function* changeProfilePermissions({ payload }) {
  yield put(profileActions.setProfileSettingsLoading(true));

  try {
    const { data } = yield call(
      profileApi.updateProfilePermissions,
      payload.userId,
      payload.permissions,
    );

    yield put(profileActions.changeProfilePermissionsSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }

  yield put(profileActions.setProfileSettingsLoading(false));
}

function* getSchoolByTenant() {
  try {
    const tenantId = yield getCookie(TENANT_ID_KEY);
    const { data } = yield call(profileApi.getSchoolByTenant, tenantId);
    yield put(profileActions.getSchoolByTenantSuccess(data));
  } catch (error) {
    yield put(profileActions.getSchoolByTenantError());
    yield put(showErrorNotification(error.messages));
  }
}

function* getProfileRoutes({ payload }) {
  try {
    const responses = yield all(
      payload.routeIds.map(routeId => call(routesApi.getRouteById, routeId)),
    );
    const data = responses.map(res => res.data);
    yield put(profileActions.getProfileRoutesSuccess(data));
  } catch (error) {
    yield put(showErrorNotification(error.messages));
  }
}

export function* getCurrentUserSaga() {
  yield takeLatest(GET_CURRENT_USER, getCurrentUser);
}

export function* changePasswordSaga() {
  yield takeLatest(CHANGE_PASSWORD, changePassword);
}

export function* getProfileSettingsSaga() {
  yield takeLatest(GET_PROFILE_SETTINGS, getProfileSettings);
}

export function* getProfileRoutesSaga() {
  yield takeLatest(GET_ROUTES_FOR_PROFILE, getProfileRoutes);
}

export function* changeProfilePermissionsSaga() {
  yield takeLatest(CHANGE_PERMISSIONS, changeProfilePermissions);
}

// export function* getSchoolByTenantSaga() {
//   yield takeLatest(GET_SCHOOL_BY_TENANT, getSchoolByTenant);
// }

export default function* rootSaga() {
  yield all([
    fork(getCurrentUserSaga),
    fork(changePasswordSaga),
    fork(getProfileSettingsSaga),
    fork(changeProfilePermissionsSaga),
    fork(getProfileRoutesSaga),
    takeLatest(GET_SCHOOL_BY_TENANT, getSchoolByTenant),
  ]);
}
